// extracted by mini-css-extract-plugin
export default {"label_spec":"SourceInfo_label_spec__DOVYS","wrap":"SourceInfo_wrap__aWheK","source":"SourceInfo_source__63hUQ","link":"SourceInfo_link__LgSEc"};